/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import DefaultOrganizationLogo from 'bundles/enterprise-legacy-learner-home/components/DefaultOrganizationLogo';
import DefaultUserLogo from 'bundles/enterprise-legacy-learner-home/components/DefaultUserLogo';

type Props = {
  photoUrl?: string;
  isUserHome: boolean;
  label?: string;
  primaryColor?: string;
  iconColor?: string;
};

/**
 * Resolves the right avatar for an org-switcher row:
 * - Imgix for orgs that have a real logo
 * - User silhouette for the "My Coursera" row
 * - Default initials/color tile for orgs without a logo
 */
export const OrgContextAvatar = ({ photoUrl, isUserHome, label, primaryColor, iconColor }: Props) => {
  if (photoUrl) {
    return <Imgix alt="" src={photoUrl} maxWidth={24} maxHeight={24} />;
  }
  if (isUserHome) {
    return <DefaultUserLogo size={24} />;
  }
  return (
    <DefaultOrganizationLogo
      size={24}
      shape="square"
      thirdPartyOrganization={{ name: label, primaryColor, iconColor }}
    />
  );
};

export default OrgContextAvatar;
